export const EditIcon = ({ color = "#DBBE78", size = 19, ...props }) => (
    <svg width={size} height={size} viewBox="0 0 19 19" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
        <path
            d="M2.4668 13.6325V16.5847H5.419L14.126 7.87763L11.1738 4.92542L2.4668 13.6325ZM16.4091 5.59459C16.7161 5.28756 16.7161 4.79159 16.4091 4.48456L14.5669 2.64238C14.2599 2.33535 13.7639 2.33535 13.4569 2.64238L12.0162 4.08306L14.9684 7.03526L16.4091 5.59459Z"
            fill={color}
        />
    </svg>
);
